/**
 * Source unique des 4 types de réaction.
 *
 * Doit rester aligné sur backend/app/routers/reactions.py::VALID_TYPES.
 * Défini ici pour que le fil (PostCard) et la page du post (PostDetail)
 * partagent exactement les mêmes libellés et le même ordre d'affichage.
 *
 * Pas de palette multicolore : la charte Break News impose #F77F00 comme
 * unique accent (cf. design_guidelines.json).
 */
import { Hand, Heart, Lightbulb, ThumbsUp } from "lucide-react";

export const REACTIONS = [
  { type: "like", Icon: ThumbsUp, label: "J'aime" },
  { type: "applause", Icon: Hand, label: "Bravo" },
  { type: "idea", Icon: Lightbulb, label: "Idée" },
  { type: "heart", Icon: Heart, label: "Coup de cœur" },
];

export const REACTION_TYPES = REACTIONS.map((r) => r.type);

export const REACTION_BY_TYPE = REACTIONS.reduce(
  (acc, r) => ({ ...acc, [r.type]: r }),
  {}
);

/** Objet de comptage vide — évite les `undefined` pendant le chargement. */
export function emptySummary() {
  return {
    counts: REACTION_TYPES.reduce((acc, t) => ({ ...acc, [t]: 0 }), {}),
    total: 0,
  };
}
